// src/pages/PublicServicesPage.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/Client";
import {API_BASE} from "../config.ts";

interface Service {
  id: number;
  name: string;
  description?: string;
  image?: string;
}

export default function PublicServicesPage() {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const resp = await api.get("/api/mobile/services");
        setServices(Array.isArray(resp.data) ? resp.data : []);
      } catch (err) {
        console.error("Error al cargar servicios:", err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return (
    <div style={{ minHeight: "100vh", padding: "1rem" }}>
      <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>Nuestros Servicios</h2>

      {loading && <p>Cargando...</p>}
      {!loading && services.length === 0 && <p>No hay servicios disponibles.</p>}

      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        {services.map((svc) => (
          <div
            key={svc.id}
            onClick={() => navigate(`/public-service/${svc.id}`)}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "0.75rem",
              border: "1px solid #eee",
              borderRadius: "12px",
              background: "#fff",
              cursor: "pointer",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            }}
          >
            {svc.image && (
              <img
                src={`${API_BASE}/api/service_images/${svc.image}`}
                alt={svc.name}
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "contain",
                  marginRight: "12px",
                }}
              />
            )}
            <div>
              <div style={{ fontWeight: 600, fontSize: "1rem" }}>
                {svc.name.toUpperCase()}
              </div>
              {svc.description && (
                <div style={{ fontSize: "0.8rem", color: "#666" }}>
                  {svc.description}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
